<div class="page-content">
    <app-page-title [pageTitle]="'page.bolletta.title' | translate" [pageSubtitle]="'page.bolletta.subtitle' | translate"></app-page-title>
    <app-bolletta />
</div>
<ng-container *ngIf="showContent$()">

    <div class="page-content mb--48 p--32" isInViewport (isInViewport)="onVisibilityChanged('promo',$event)" [threshold]="0.2" *ngIf="showBenhmarkPromo$()">
        <mat-card  class="rounded bg-sky p--24" >
            <mat-card-content>
                <div class="d-flex flex-column flex-lg-row gap-16">
                    <div class="col-12 col-lg-6 text-dark">
                        <h5 class="text-primary" [@fadeInUp]="{value: visibilityState['promo'], params: {delay: '300ms'}}">Vuoi ancora di piu?</h5>
                        <h3 class="text-dark" [@fadeInUp]="{value: visibilityState['promo'], params: {delay: '500ms'}}">Ti abbiamo riservato un vantaggio competitivo</h3>
                        <h2 class="text-primary" [@fadeInUp]="{value: visibilityState['promo'], params: {delay: '700ms'}}">Ottieni i Benchmark per 3 partite IVA a tua scelta</h2>
                        <div clss="promo-description text-dark mt--24" [@fadeInUp]="{value: visibilityState['promo'], params: {delay: '900ms'}}">
                            <p>Analizza i competitor o le aziende di cui vuoi ottenere informazioni utili alla tua
                                strategia di marketing</p>
                            <p>Comincia subito nella tua area Selfcaring</p>
                        </div>
                        <button mat-flat-button color="primary" class="mt--24 rounded " (click)="goToSelfcaring()"
                        [@fadeInUp]="{value: visibilityState['promo'], params: {delay: '1100ms'}}">
                        {{'Ottieni i Benchmark' | translate }}</button>
                    </div>
                    <div class="col-12 col-lg-6 d-flex place-content-center">
                        <img [ngSrc]="'/images/background/benchmark-devices.webp'" width="450" height="300"
                            alt="Benchmark Devices" class="img-responsive rounded" />
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="container-fluid p--0" isInViewport (isInViewport)="onVisibilityChanged('related',$event)" [threshold]="0.2">
        <app-section-title [sectionclass]="'text-center pb--48 pt--48'" [titletag]="'Massimizza i tuoi profitti'" [title]="'Scopri i modi in cui Delfi.ai guida la tua azienda verso il successo'"
        [@fadeInUp]="{value: visibilityState['related'], params: {delay: '300ms'}}"></app-section-title>
        <products-related [@fadeInUp]="{value: visibilityState['related'], params: {delay: '500ms'}}" [productsTags]="'promobanner'" [layout]="'promo-carousel'"></products-related>
    </div>
</ng-container>